/**
 * OneAmerica Category 2 demographic Single Pay calibration bands.
 *
 * Historical datasets: 6cc9415cc722a9d3d6e4+d2030990d054674ecece
 * Curves: 630
 * Rows: 6227 (4410 historical + 1817 fresh missing-ladder/boundary points)
 * Artifact SHA-256: 75a5e0672c21b81b3e60e2a099cfa0fda01b4725b4f67d56926a6d88a91eab5a
 *
 * Gender independence was validated in dataset 1590994c9dde3c706cfa: all eight matched
 * Female/Male probes produced identical carrier outputs, so gender is intentionally omitted.
 *
 * Stored as packed tuple data so generated calibration points do not become
 * thousands of JavaScript AST and source-map nodes during production builds.
 */

import type { PackedBandEntry } from './oneAmericaPricingUtils';
import rawBands from './oneAmericaCat2DemographicSinglePayBands.data.json?raw';

export const OA_CAT2_DEMOGRAPHIC_SINGLE_PAY_AGES = [40, 45, 48, 50, 55, 60, 65, 70, 75] as const;

export const OA_CAT2_DEMOGRAPHIC_SINGLE_PAY_BANDS = JSON.parse(rawBands) as Record<
  string,
  PackedBandEntry[]
>;
